import { IStyle, mergeStyleSets } from "@fluentui/merge-styles";
import { Link } from "@fluentui/react";
import { LinkRegular } from "@fluentui/react-icons";
import { GridColDef, GridRowSelectionModel } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { IPartnerEngagementsTableProps } from "../../interfaces/PartnerView.interfaces";
import { DATA_GRID_CONFIG } from "../../SharedComponents/Constants/CustomCustomerList.constants";
import { CustomDataGrid } from "../../SharedComponents/CustomDataGrid/CustomDataGrid";
import { handleToggleDataGridRowSelection } from "../../Utils/js-common";

const styles = mergeStyleSets({
  featureTable: {
    height: 600,
    width: "100%"
  } as IStyle
});

export default function PartnerEngagementTable(props: IPartnerEngagementsTableProps) {
  const [selectionModel, setSelectionModel] = useState<GridRowSelectionModel>([]);
  const [paginationOptions, setPaginationOptions] = useState(DATA_GRID_CONFIG.pagination);
  const handleSelection = handleToggleDataGridRowSelection(selectionModel, setSelectionModel);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const elements = document.getElementsByClassName("MuiDataGrid-virtualScroller");
      if (elements.length > 0) {
        Array.from(elements).forEach((element) => {
          element.setAttribute("tabIndex", "0");
        });
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  const columns: GridColDef[] = [
    {
      headerName: "CRMLink",
      field: "crmurl",
      minWidth: 180,
      sortable: true,
      flex: 1,
      renderCell: (params) => (
        <Link
          style={{
            color: "rgb(0, 120, 212)",
            textDecoration: "none",
            fontSize: 26,
            cursor: "pointer"
          }}
          href={params.row.crmurl}
          title={params.row.crmurl}
          target="_blank"
          rel="noopener noreferrer"
          tabIndex={params.row.tabIndex}
        >
          <LinkRegular />
        </Link>
      )
    },
    {
      headerName: "Engagement Id",
      field: "engagementId",
      minWidth: 250,
      sortable: true,
      flex: 1
    },
    {
      headerName: "Title",
      field: "title",
      minWidth: 150,
      sortable: true,
      flex: 1
    },
    {
      headerName: "Program Name",
      field: "programName",
      minWidth: 150,
      sortable: true,
      flex: 1
    },
    {
      headerName: "Meeting Type",
      field: "meetingType",
      minWidth: 250,
      sortable: true,
      flex: 1
    },
    {
      headerName: "Meeting Sub Type",
      field: "meetingSubType",
      minWidth: 200,
      sortable: true,
      flex: 1
    },
    {
      headerName: "Date Confirmed Start Time",
      field: "dateConfirmedStartTime",
      minWidth: 180,
      sortable: true,
      flex: 1,
      renderCell: ({ value }) => (value ? new Date(value).toLocaleDateString() : "")
    },
    {
      headerName: "Date Confirmed End Time",
      field: "dateConfirmedEndTime",
      minWidth: 180,
      sortable: true,
      flex: 1,
      renderCell: ({ value }) => (value ? new Date(value).toLocaleDateString() : "")
    },
    {
      headerName: "Engagement Owner",
      field: "engagementOwner",
      minWidth: 150,
      sortable: true,
      flex: 1
    },
    {
      headerName: "Engagement Status",
      field: "engagementStatus",
      minWidth: 200,
      sortable: true,
      flex: 1
    },
    {
      headerName: "MSFT Attendees Confirmed",
      field: "msftAttendeesConfirmed",
      minWidth: 180,
      sortable: true,
      flex: 1
    },
    {
      headerName: "PartnerOneID",
      field: "partnerOneID",
      minWidth: 250,
      sortable: true,
      flex: 1
    },
    {
      headerName: "PartnerOneName",
      field: "partnerOneName",
      minWidth: 200,
      sortable: true,
      flex: 1
    }
  ];

  return (
    <div className={styles.featureTable}>
      <CustomDataGrid
        enableUrlParams
        rows={{ values: props?.tableData ?? [], count: props.tableData?.length ?? 0 }}
        columns={columns}
        getRowId={(row) => JSON.stringify(row)}
        onRowSelectionModelChange={handleSelection}
        rowSelectionModel={selectionModel}
        paginationOptions={paginationOptions}
        setPaginationOptions={setPaginationOptions}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 25 }
          }
        }}
        kustoLink={props.kustoLink}
      />
    </div>
  );
}
